<div class="authentication-container">
  <div class="hero-section">
    <div class="header">
      <div class="neo-hire-icon">
        <img src="./assets/icons-svg/neo-hire.svg" />
      </div>
      <div class="neo-hire-details">
        <h3 class="title">Hire Smarter. Hire Faster. Powered by AI.</h3>
        <span class="subtitle">
          Our platform combines speed, precision, automation to help you find the right candidates
          in less time, with better outcomes. our AI ensures you hire top talent quickly, efficiently, and
          confidently.
        </span>
      </div>
      <app-authentication-carousel></app-authentication-carousel>
    </div>
    <div class="footer">
      <img src="./assets/icons-svg/star.svg" /> 
      Trusted by high-growth teams to scale hiring efficiently
      <img src="./assets/icons-svg/star.svg" />
    </div>
  </div>
  <div class="form-section">
    <div class="login-company-logo">
      <img [src]="sourceImg" alt="Company Logo" />
    </div>
    <div class="form-container" *ngIf="!otpRequired">
      <div class="login-details">
        <h3 class="title">Welcome Back <img src="./assets/icons-svg/waving-hand.svg" /></h3>
        <span class="subtitle">
          Sign in to access your workspace and continue your journey.
        </span>
      </div>

      <div class="login-form" *ngIf="regularLoginEnabled" [formGroup]="loginSection">
        <div class="form">
          <div class="neo-input-wrapper">
            <label for="login_email">Email Address</label>
            <input pInputText type="email" name="email" id="login_email" placeholder="Enter your email address"
              formControlName="email" class="lg" />
          </div>
          <div class="neo-input-wrapper">
            <label for="login_password">Password</label>
            <input pInputText [type]="passwordShow ? 'text' : 'password'" name="password" id="login_password"
              placeholder="Enter your password" formControlName="password" class="lg" />
            <div class="signin-addon">
              <div class="show-pwd">
                <p-checkbox inputId="showPasswordCheckbox" (onChange)="toggleShowHidePwd()" [binary]="true"></p-checkbox>
                <label for="showPasswordCheckbox" class="show-label_spacing">Show Password</label>
              </div>
              <div>
                <p class="forget-label_spacing" id="login_forgot_password" (click)="navigateToForgotPassword()">Forgot Password?</p>
              </div>
            </div>
          </div>
        </div>
        <button pButton class="neo-btn" id="login_submit" (click)="signIn()" [disabled]="isLoading || loginSection.invalid" [loading]="isLoading">Sign In</button>
      </div>

      <div *ngIf="invalidCred" class="error-msg" style="text-align: center; margin-top: 15px;">
        Invalid email address or password
      </div>

      <div *ngIf="metadataLoaded && ssoProviders && ssoProviders.length > 0" class="sso-section">
        <div *ngIf="regularLoginEnabled" class="divider">
          <span class="divider-text">Or continue with</span>
        </div>
      
        <div *ngIf="!regularLoginEnabled" class="only-sso-login-method">
          <span class="only-sso-login-icon">
            <i class="pi pi-lock"></i>
          </span>
          <h3 class="only-sso-login-title">Secure Authentication</h3>
          <p class="no-login-message">
            Please use your organization's secure authentication to access your workspace.
          </p>
        </div>
      
        <div class="sso-buttons">
          <button *ngFor="let provider of ssoProviders" pButton class="neo-btn outline"
            [class.sso-loading]="isSSOProviderLoading(provider)" [disabled]="isSSOProviderLoading(provider) || isLoading"
            (click)="initiateSSO(provider)" type="button">
            <!-- <i [ngClass]="getSSOProviderIcon(provider)" class="sso-pi-icon"></i> -->
            <span>{{provider}}</span>
            <p-progressSpinner *ngIf="isSSOProviderLoading(provider)" [style]="{height: '16px', width: '16px'}"
              strokeWidth="7" animationDuration="0.5s">
            </p-progressSpinner>
          </button>
        </div>
      
        <div *ngIf="ssoError" class="error-msg sso-error">
          {{ssoError}}
        </div>
      </div>

      <div *ngIf="!metadataLoaded" class="sso-section">
        <div class="divider">
          <span class="divider-text">Or continue with</span>
        </div>
        <div class="sso-loading-placeholder">
          <p-progressSpinner [style]="{height: '20px', width: '20px'}" strokeWidth="7" animationDuration="0.5s">
          </p-progressSpinner>
          <span class="loading-text">Loading SSO options...</span>
        </div>
      </div>

      <div *ngIf="metadataLoaded && !regularLoginEnabled && (!ssoProviders || ssoProviders.length === 0)"
        class="no-login-methods">
        <div class="no-login-icon">
          <i class="pi pi-sign-in"></i>
        </div>
        <h3 class="no-login-title">No Login Methods Available</h3>
        <p class="no-login-message">
          No authentication methods have been configured for this workspace.
          Please contact your administrator to set up login options.
        </p>
      </div>
    </div>

    <div class="form-container" *ngIf="otpRequired">
      <div class="login-details">
        <h3 class="title">OTP Verification</h3>
        <span class="subtitle">
          We have sent the code to <strong>{{loginEmail}}</strong>
        </span>
      </div>

     <app-login-otp-verification [routingDetails]="routingDetails" [userDetails]="userDetails" [privilegeData]="privilegeData" [otpRequired]="otpRequired" [loginEmail]="loginEmail" [onlyOTP]="true"></app-login-otp-verification>
    </div>
  </div>
</div>

<!-- <div *ngIf="otpRequired || true">
  <app-login-otp-verification [routingDetails]="routingDetails" [userDetails]="userDetails" [privilegeData]="privilegeData" [otpRequired]="otpRequired" [loginEmail]="loginEmail"></app-login-otp-verification>
</div> -->

<p-toast></p-toast>

@if (false) {
<div (window:resize)="onResize()" [ngStyle]="{'height': height}" class="opt-verification" *ngIf="!otpRequired">
  <div class="verification-content">
    
    <div class="illustration-section">
      <div class="background-shadow"></div>
        <div class="image-container">
          <img [src]="coverImage" alt="Welcome" class="illustration-image" />
        </div>
      
      <h2 class="verification-title">Welcome Back</h2>
      <p class="verification-description">
        Sign in to access your workspace and continue your journey.
      </p>
    </div>

    <div class="form-section">
      <div class="logo-container">
        <img class="logo" [src]="sourceImg" alt="Company Logo" />
      </div>
      <h1 class="form-title">Sign In</h1>
      <p class="form-subtitle">The key to happiness is to login.</p>

      <div class="form-card">
        <form *ngIf="regularLoginEnabled" [formGroup]="loginSection">
          <div class="form-group">
            <label class="form-label">Email Address</label>
            <div class="email-input">
              <i class="pi pi-envelope"></i>
              <input formControlName="email" type="email" pInputText (click)="invalidCred = false" />
            </div>
            <app-handle-error [clicked]="clicked" [control]="loginSection.get('email')" name="Email ID"></app-handle-error>
          </div>

          <div class="form-group">
            <label class="form-label">Password</label>
            <div class="email-input">
              <i class="pi pi-lock"></i>
              <input formControlName="password" type="password" class="passwordInput" pInputText (click)="invalidCred = false" />
            </div>
            <app-handle-error [clicked]="clicked" [control]="loginSection.get('password')" name="Password" fieldType="password"></app-handle-error>
          </div>

          <div class="signin-addon">
            <div class="show-pwd">
              <p-checkbox id="showPasswordCheckbox" (onChange)="toggleShowHidePwd()" [binary]="true"></p-checkbox>
              <label for="showPasswordCheckbox" class="show-label_spacing">Show Password</label>
            </div>
            <div>
              <p class="forget-label_spacing" routerLink="/forgotPassword">Forgot Password?</p>
            </div>
          </div>

          <button class="verify-button" [disabled]="!loginSection.valid" (click)="signIn()">
            <span *ngIf="!isLoading">Sign In</span>
            <p-progressSpinner *ngIf="isLoading" [style]="{height: '20px', width: '20px'}" strokeWidth="7" animationDuration="0.5s"></p-progressSpinner>
          </button>
        </form>

        <div *ngIf="metadataLoaded && ssoProviders && ssoProviders.length > 0" class="sso-section">
          <div *ngIf="regularLoginEnabled" class="divider">
            <span class="divider-text">Or continue with</span>
          </div>
          
          <div *ngIf="!regularLoginEnabled" class="sso-only-message">
            <div class="sso-only-icon">
              <i class="pi pi-lock"></i>
            </div>
            <p class="sso-only-description">
              Welcome! Please use your organization's secure authentication to access your workspace.
            </p>
          </div>
          
          <div class="sso-buttons">
            <button 
              *ngFor="let provider of ssoProviders" 
              class="sso-button"
              [class.sso-loading]="isSSOProviderLoading(provider)"
              [disabled]="isSSOProviderLoading(provider) || isLoading"
              (click)="initiateSSO(provider)"
              type="button">
              <!-- <i [ngClass]="getSSOProviderIcon(provider)" class="sso-pi-icon"></i> -->
              <span>{{provider}}</span>
              <p-progressSpinner 
                *ngIf="isSSOProviderLoading(provider)" 
                [style]="{height: '16px', width: '16px'}" 
                strokeWidth="7" 
                animationDuration="0.5s">
              </p-progressSpinner>
            </button>
          </div>
          
          <div *ngIf="ssoError" class="error-msg sso-error">
            {{ssoError}}
          </div>
        </div>
        
        <div *ngIf="!metadataLoaded" class="sso-section">
          <div class="divider">
            <span class="divider-text">Or continue with</span>
          </div>
          <div class="sso-loading-placeholder">
            <p-progressSpinner 
              [style]="{height: '20px', width: '20px'}" 
              strokeWidth="7" 
              animationDuration="0.5s">
            </p-progressSpinner>
            <span class="loading-text">Loading SSO options...</span>
          </div>
        </div>

        <div *ngIf="metadataLoaded && !regularLoginEnabled && (!ssoProviders || ssoProviders.length === 0)" class="no-login-methods">
          <div class="no-login-icon">
            <i class="pi pi-trash"></i>
          </div>
          <h3 class="no-login-title">No Login Methods Available</h3>
          <p class="no-login-message">
            No authentication methods have been configured for this workspace. 
            Please contact your administrator to set up login options.
          </p>
        </div>

        <div *ngIf="invalidCred" class="error-msg" style="text-align: center; margin-top: 15px;">
          Invalid email address or password
        </div>
      </div>
    </div>

  </div>
</div>
}